import React from 'react';
  
  const Cancellation_Policy = ({
    isMobile,
    is_policy_page
  }) =>  {
	return (
      <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
        <h2 style={{color: 'rgb(228,228,231)', fontWeight: `${is_policy_page ? 600 : 500}`, fontSize: `${is_policy_page ? '1.5rem' : '1rem'}`, margin: 0}}>
            {is_policy_page ? 'Cancellation Policy' : 'How to Cancel'}
        </h2>
        <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', marginTop: '.5rem'}}>
            You can cancel your subscription anytime from the <a href='/settings' style={{textDecoration: 'underline', color: '#FFFF00'}}>settings</a> page. After cancellation:
        </p>
        <div style={{margin: '1rem 0'}}>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.25rem'}}>
                {/* Bullet point */}
                {is_policy_page ? (
                    <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                ) : (
                    <div style={{borderRadius: '50%', background: 'rgb(59,130,246,.1)', width: '1.25rem', height: '1.25rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <div style={{background: 'rgb(59,130,246)', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                    </div>
                )}
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    Your subscription will remain active until the end of your current billing period
                </p>
            </div>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                {/* Bullet point */}
                {is_policy_page ? (
                    <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                ) : (
                    <div style={{borderRadius: '50%', background: 'rgb(59,130,246,.1)', width: '1.25rem', height: '1.25rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <div style={{background: 'rgb(59,130,246)', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                    </div>
                )}
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    You won't be charged again after cancellation
                </p>
            </div>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                {/* Bullet point */}
                {is_policy_page ? (
                    <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                ) : (
                    <div style={{borderRadius: '50%', background: 'rgb(59,130,246,.1)', width: '1.25rem', height: '1.25rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <div style={{background: 'rgb(59,130,246)', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                    </div>
                )}
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    No partial refunds are provided for unused portions of the current billing period
                </p>
            </div>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                {/* Bullet point */}
                {is_policy_page ? (
                    <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                ) : (
                    <div style={{borderRadius: '50%', background: 'rgb(59,130,246,.1)', width: '1.25rem', height: '1.25rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <div style={{background: 'rgb(59,130,246)', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                    </div>
                )}
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    You can continue using all features until your subscription expires
                </p>
            </div>
        </div>
        {is_policy_page ? (
            <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', marginTop: '.5rem'}}>
                To cancel your subscription, go to the settings page.
            </p>
        ) : (
            /* Button */
            <div style={{marginTop: '1rem'}}>
                <button onClick={() => window.location.href = '/settings'} style={{boxShadow: '0 0 20px rgba(255, 191, 0, .3)', background: '#FFFF00', fontWeight: 600, fontSize: '.875rem', width: `${isMobile ? '100%' : 'fit-content'}`, marginLeft: 'auto', padding: '.5rem 1rem', borderRadius: '14px', border: 'none', cursor: 'pointer'}}>
                    <div style={{display: 'flex', gap: '.5rem', alignItems: 'center', justifyContent: 'center'}}>
                        Go to Settings
                    </div>
                </button>
            </div>
        )}
    </div>
	);
  }
  
  export default Cancellation_Policy;
  